import PropTypes from 'prop-types';

import {
  KEY_LABEL_FONT_COLOR,
  KEY_LABEL_FONT_SIZE,
  KEY_LABEL_FONT_STYLE,
  KEY_LABEL_FONT_WEIGHT,
  KEY_LABEL_STICK_TO,
  KEY_LABEL_TEXT_DECORATION,
  KEY_LABEL_TEXT_TRANSFORM,
  KEY_TEXT_STATIC_FONT_COLOR,
  KEY_TEXT_STATIC_FONT_FAMILY,
  KEY_TEXT_STATIC_FONT_SIZE,
  KEY_TEXT_STATIC_FONT_STYLE,
  KEY_TEXT_STATIC_FONT_WEIGHT,
  KEY_TEXT_STATIC_TEXT_DECORATION,
  KEY_TEXT_STATIC_TEXT_TRANSFORM,
  KEY_TEXTFIELD_FONT_COLOR,
  KEY_TEXTFIELD_FONT_SIZE,
  KEY_TEXTFIELD_FONT_STYLE,
  KEY_TEXTFIELD_FONT_WEIGHT,
  KEY_TEXTFIELD_TEXT_DECORATION,
  KEY_TEXTFIELD_TEXT_TRANSFORM,
} from '../../../const/keysBlockStyling';

import {
  propTypeFontStyle,
  propTypeFontWight,
  propTypeStickTo,
  propTypeTextDecoration,
  propTypeTextTransform,
} from './basic';

const propTypeBlockStyling = PropTypes.shape({
  [KEY_LABEL_FONT_COLOR]: PropTypes.string,
  [KEY_LABEL_FONT_SIZE]: PropTypes.number,
  [KEY_LABEL_FONT_STYLE]: propTypeFontStyle,
  [KEY_LABEL_FONT_WEIGHT]: propTypeFontWight,
  [KEY_LABEL_STICK_TO]: propTypeStickTo,
  [KEY_LABEL_TEXT_DECORATION]: propTypeTextDecoration,
  [KEY_LABEL_TEXT_TRANSFORM]: propTypeTextTransform,
  [KEY_TEXT_STATIC_FONT_COLOR]: PropTypes.string,
  [KEY_TEXT_STATIC_FONT_FAMILY]: PropTypes.string,
  [KEY_TEXT_STATIC_FONT_SIZE]: PropTypes.number,
  [KEY_TEXT_STATIC_FONT_STYLE]: propTypeFontStyle,
  [KEY_TEXT_STATIC_FONT_WEIGHT]: propTypeFontWight,
  [KEY_TEXT_STATIC_TEXT_DECORATION]: propTypeTextDecoration,
  [KEY_TEXT_STATIC_TEXT_TRANSFORM]: propTypeTextTransform,
  [KEY_TEXTFIELD_FONT_COLOR]: PropTypes.string,
  [KEY_TEXTFIELD_FONT_SIZE]: PropTypes.number,
  [KEY_TEXTFIELD_FONT_STYLE]: propTypeFontStyle,
  [KEY_TEXTFIELD_FONT_WEIGHT]: propTypeFontWight,
  [KEY_TEXTFIELD_TEXT_DECORATION]: propTypeTextDecoration,
  [KEY_TEXTFIELD_TEXT_TRANSFORM]: propTypeTextTransform,
});

export default propTypeBlockStyling;
